import React from 'react';
import './CategoryGrid.css';

function CategoryGrid({ categories, onCategoryClick }) {
  return (
    <section className="category-section">
      <div className="category-container">
        <h3 className="category-title">Browse By Category</h3>
        
        {categories.length === 0 ? (
          <div className="no-results">
            <p>No categories found. Try a different search.</p>
          </div>
        ) : (
          <div className="category-grid">
            {categories.map((category) => (
              <button
                key={category.id}
                className="category-card"
                onClick={() => onCategoryClick(category)}
                aria-label={`Browse ${category.name} businesses`}
              >
                <div className="category-icon">{category.icon}</div>
                <h4 className="category-name">{category.name}</h4>
                <p className="category-description">{category.description}</p>
                {category.businesses.length > 0 && (
                  <span className="business-count">
                    {category.businesses.length} business{category.businesses.length !== 1 ? 'es' : ''}
                  </span>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default CategoryGrid;
